export const BRAND = {
  name: "Celestial OS",
  company: "AFAQ ALNASEEM TRADING L.L.C",
  tagline: "Enterprise Intelligence",
  colors: {
    primary: "#bdb2ff",
    secondary: "#060e20",
    accent: "#cfeda2",
    danger: "#ff6b6b",
    warning: "#ffd6a5",
    success: "#cfeda2",
    info: "#c8bfff",
    textMuted: "#7a8aa0",
  },
  fontFamily: "'Space Grotesk', 'Manrope', -apple-system, BlinkMacSystemFont, sans-serif",
  borderRadius: "16px",
  glassEffect: "rgba(255,255,255,0.02)",
  blur: "blur(60px)",
  markets: ["UAE", "Oman", "Saudi", "Kuwait", "Qatar", "Bahrain"],
  languages: ["AR", "EN", "FA"],
  currency: "AED",
  timezone: "Asia/Dubai",
  vat: 0.05, // 5%
  logo: {
    light: "/brand/afaq-logo-light.png",
    dark: "/brand/afaq-logo-dark.png",
    icon: "/brand/afaq-icon.png",
  },
};

export const PRODUCTS = {
  ENZO: "ENZO Italy",
  LIZZE: "LIZZE Brazilian",
};

export const MODULES = {
  SALES: "Sales",
  OPERATIONS: "Operations",
  INTELLIGENCE: "Intelligence",
  AUTOMATION: "Automation",
  ADMIN: "Admin",
};

export default BRAND;